<div class="ui-project__header">
  <div class="actions__buttons">
    <list-search />

    <list-filters-btn-v2 class="ml-auto" [filters]="ProjectTeamFiltersComponent" />
  </div>
</div>

<div class="container-fluid--30 pt-3">
  <app-list
    *ngIf="inited"
    [config]="config"
    [filters]="ProjectTeamFiltersComponent"
    [emptyTemplate]="emptyTemplate"
    [searchName]="'ProjectTeam.List.search' | translate"
    [selected]="selected"
    [showToggleMenu]="showToggleMenu.bind(this)"
    #list
  />
</div>

<ng-template #emptyTemplate>
  <div class="d-flex flex-column align-items-center mt-4 empty">
    <img
      draggable="false"
      src="/assets/img/team-placeholder-icon.svg"
      alt="{{ 'ProjectChanges.List.noRecords' | translate }}"
      class="mb-4 mt-4"
    />
    <div class="mt-2">{{ 'ProjectTeam.List.noRecords' | translate }}</div>
    <app-button
      [permission]="{
        group: PermissionsGroups.PROJECT_TEAM,
        action: 'ADD',
        objectCreatorId: [projectPreviewService?.project?.basicDataBox?.responsibleEmployee?.id]
      }"
      (onClick)="addNewTeamMember()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.SECONDARY_BLUE,
        text: 'ProjectTeam.addNewTeamMember' | translate,
        prependSrc: './assets/img/ic-user-plus.svg'
      }"
    />
  </div>
</ng-template>

<project-team-employee-cell #projectTeamEmployeeCellComponent />
<project-team-function-cell #projectTeamFunctionCellComponent />
<project-team-phone-cell #projectTeamPhoneCellComponent />
<project-team-hourly-rate-cell #projectTeamHourlyRateCellComponent />
<project-team-role-cell #projectTeamRoleCellComponent />
<project-team-role-project-cell #projectTeamRoleProjectCellComponent />
<project-team-email-cell #projectTeamEmailCellComponent />
